module.exports = __webpack_public_path__ + "9b7023c3ca65d70e18c1c7ec0ea582f3.pdf";